import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_CENTRAL_BANK_PAYMENT_LIST: string = typeCreatorV2(
  'CentralBankPaymentListReducer',
  'SetCentralBankPaymentsList'
);

export const FETCH_CENTRAL_BANK_PAYMENTS: string = typeCreatorV2(
  'CentralBankPaymentListReducer',
  'FetchCentralBankPayments'
);

export const MATCH_CENTRAL_BANK_PAYMENTS: string = typeCreatorV2(
  'CentralBankPaymentListReducer',
  'MatchCentralBankPayments'
);

export const SET_CENTRAL_BANK_PAYMENT_STATUS_CODES_LIST: string = typeCreatorV2(
  'CentralBankPaymentListReducer',
  'SetCentralBankPaymentStatusCodesList'
);

export const SET_CENTRAL_BANK_PAYMENT_ACCOUNTS_LIST: string = typeCreatorV2(
  'CentralBankPaymentListReducer',
  'SetCentralBankPaymentAccountsList'
);

export const UPDATE_CENTRAL_BANK_PAYMENT_STATUS: string = typeCreatorV2(
  'CentralBankPaymentListReducer',
  'UpdateCentralBankPaymentStatus'
);
